import { render } from "./instant.vue?vue&type=template&id=238c65dc"
import script from "./instant.vue?vue&type=script&lang=js"
export * from "./instant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__